<template>
    <div class="showcase-list-page" v-wechat-title="`风采展示_双优云桥-智慧研修平台`">
        <div class="showcase-wrap">
            <div class="crumb-bar">
                <a href="javascript:;" @click.prevent="goHome">项目首页</a>
                <span class="sep">/</span>
                <span class="cur">风采展示</span>
            </div>

            <div class="panel" v-loading="loading">
                <div class="showcase-grid" v-if="pagedList.length">
                    <a
                        v-for="item in pagedList"
                        :key="item.id"
                        href="javascript:;"
                        class="showcase-item"
                        @click.prevent="previewItem(item)"
                    >
                        <div
                            class="showcase-cover"
                            :class="{ 'is-video': item.fileType === 'video' }"
                            :style="item.coverStyle"
                        >
                            <span class="cover-badge">{{ item.tag }}</span>
                            <span v-if="item.fileType === 'video'" class="cover-play"></span>
                        </div>
                        <div class="showcase-info">
                            <h4>{{ item.title }}</h4>
                            <p>{{ item.desc }}</p>
                        </div>
                    </a>
                </div>

                <ph-empty
                    v-else-if="!loading"
                    size="page"
                    text="暂无风采内容"
                />

                <div class="pager-wrap" v-if="tableData.length > 0">
                    <pagination
                        :total="tableData.length"
                        :page.sync="pages.currentPage"
                        :limit.sync="pages.pageSize"
                        @pagination="handlePageChange"
                    />
                </div>
            </div>
        </div>

        <el-dialog
            :title="previewTitle"
            :visible.sync="showVideoDialog"
            width="800px"
            append-to-body
            destroy-on-close
            @closed="onVideoDialogClosed"
        >
            <video
                v-if="previewVideoUrl"
                :src="previewVideoUrl"
                controls
                autoplay
                class="preview-video"
                disablePictureInPicture
                controlslist="nodownload"
            ></video>
        </el-dialog>
    </div>
</template>

<script>
import dayjs from 'dayjs'
import pagination from '@/common/community/pagination.vue'
import PhEmpty from './components/ph-empty.vue'

export default {
    name: 'ProjectHomeShowcaseList',
    components: { pagination, PhEmpty },
    data() {
        return {
            loading: false,
            pages: {
                currentPage: 1,
                pageSize: 9
            },
            tableData: [],
            showVideoDialog: false,
            previewVideoUrl: '',
            previewTitle: ''
        }
    },
    computed: {
        projectId() {
            return this.$route.params.id
        },
        pagedList() {
            const start = (this.pages.currentPage - 1) * this.pages.pageSize
            return this.tableData.slice(start, start + this.pages.pageSize)
        }
    },
    methods: {
        goHome() {
            this.$router.push(`/projectHome/${this.projectId}`)
        },
        handlePageChange(data) {
            this.pages.currentPage = data.pageIndex
            this.pages.pageSize = data.pageSize
        },
        getFileTypeByIdentifier(identifier) {
            if (!identifier) return 'video'
            const fileName = String(identifier).split('?')[0].toLowerCase()
            let suffix = ''
            if (fileName.includes('_')) {
                const parts = fileName.split('_')
                suffix = parts[parts.length - 1]
            } else if (fileName.includes('.')) {
                suffix = fileName.slice(fileName.lastIndexOf('.') + 1)
            } else {
                suffix = fileName
            }
            const imageSuffixList = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg']
            return imageSuffixList.includes(suffix) ? 'image' : 'video'
        },
        mapItem(item, idx) {
            const fileType = this.getFileTypeByIdentifier(item.identifier)
            const mediaUrl = item.identifier ? `${this.downloadURL}${item.identifier}` : ''
            return {
                id: item.id || `showcase-${idx}`,
                title: item.name || '未命名成果',
                desc: item.createTime ? dayjs(item.createTime).format('YYYY-MM-DD HH:mm') : '--',
                tag: fileType === 'image' ? '回顾 · 图片' : '回顾 · 视频',
                fileType,
                identifier: item.identifier || '',
                mediaUrl,
                coverStyle: fileType === 'image' && mediaUrl
                    ? { backgroundImage: `url(${mediaUrl})` }
                    : ''
            }
        },
        async fetchList() {
            if (!this.projectId) {
                this.tableData = []
                return
            }
            this.loading = true
            try {
                const res = await this.$Api.Project.getProjectFile({
                    projectId: this.projectId
                })
                const list = (res && res.data && res.data['项目回顾']) || []
                this.tableData = list.map((item, idx) => this.mapItem(item, idx))
                this.pages.currentPage = 1
            } catch (e) {
                this.tableData = []
            } finally {
                this.loading = false
            }
        },
        previewItem(item) {
            if (!item || !item.identifier) {
                this.$message.error('暂无内容')
                return
            }
            if (item.fileType === 'image') {
                const imageList = this.tableData
                    .filter(row => row.fileType === 'image' && row.mediaUrl)
                    .map(row => row.mediaUrl)
                if (!imageList.length) return
                const currentIndex = imageList.findIndex(url => url === item.mediaUrl)
                this.$previewImgs(imageList, currentIndex > -1 ? currentIndex : 0)
                return
            }
            this.previewTitle = item.title || '视频预览'
            this.previewVideoUrl = item.mediaUrl
            this.showVideoDialog = true
        },
        onVideoDialogClosed() {
            this.previewVideoUrl = ''
            this.previewTitle = ''
        }
    },
    mounted() {
        this.fetchList()
    },
    watch: {
        '$route.params.id'() {
            this.fetchList()
        }
    }
}
</script>

<style lang="less" scoped>
.showcase-list-page {
    background: #f5f7fa;
    min-height: 60vh;
    padding: 24px 0 48px;
    line-height: 1.5;
}

.showcase-wrap {
    width: 990px;
    max-width: 100%;
    margin: 0 auto;
    box-sizing: border-box;
}

.crumb-bar {
    font-size: 13px;
    color: #999;
    margin-bottom: 16px;

    a {
        color: #01A2FD;
        text-decoration: none;
    }

    .sep {
        margin: 0 8px;
        color: #ccc;
    }

    .cur {
        color: #666;
    }
}

.panel {
    background: #fff;
    border: 1px solid rgba(199, 199, 199, 0.4);
    border-radius: 4px;
    overflow: hidden;
    min-height: 240px;
}

.showcase-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    padding: 24px;
}

.showcase-item {
    display: flex;
    flex-direction: column;
    border: 1px solid rgba(199, 199, 199, 0.4);
    border-radius: 6px;
    overflow: hidden;
    text-decoration: none;
    color: inherit;
    background: #fff;
    transition: box-shadow 0.2s, border-color 0.2s;

    &:hover {
        border-color: rgba(1, 162, 253, 0.45);
        box-shadow: 0 6px 18px rgba(1, 162, 253, 0.12);

        h4 {
            color: #01A2FD;
        }
    }
}

.showcase-cover {
    height: 160px;
    background:
        radial-gradient(circle at 85% 20%, rgba(255, 255, 255, 0.4), transparent 40%),
        linear-gradient(145deg, #7ec2ff 0%, #cfe8ff 55%, #eaf6ff 100%);
    background-size: cover;
    background-position: center;
    position: relative;
    display: flex;
    align-items: flex-end;
    padding: 12px;
    box-sizing: border-box;

    &.is-video {
        background: linear-gradient(145deg, #1b2a41 0%, #334e68 100%);
    }
}

.cover-badge {
    font-size: 12px;
    color: #fff;
    padding: 4px 10px;
    background: rgba(1, 162, 253, 0.92);
    border-radius: 3px;
    z-index: 1;
}

.cover-play {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 48px;
    height: 48px;
    margin: -24px 0 0 -24px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.35);
    border: 2px solid rgba(255, 255, 255, 0.75);

    &::after {
        content: "";
        position: absolute;
        left: 50%;
        top: 50%;
        border-style: solid;
        border-width: 8px 0 8px 14px;
        border-color: transparent transparent transparent #fff;
        transform: translate(-30%, -50%);
    }
}

.showcase-info {
    padding: 14px 14px 16px;

    h4 {
        margin: 0 0 8px;
        font-size: 15px;
        font-weight: 400;
        color: #333;
        line-height: 1.4;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    p {
        margin: 0;
        font-size: 12px;
        color: #999;
        line-height: 1.5;
    }
}

.pager-wrap {
    padding: 8px 16px 16px;
}

.preview-video {
    width: 100%;
    max-height: 70vh;
    background: #000;
    display: block;
}

@media screen and (min-width: 1250px) {
    .showcase-wrap {
        width: 1200px;
    }
}

@media (max-width: 960px) {
    .showcase-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 600px) {
    .showcase-grid {
        grid-template-columns: 1fr;
    }
}
</style>
